import { render, staticRenderFns } from "./ProductActions.vue?vue&type=template&id=5c7ff91c&scoped=true&"
import script from "./ProductActions.vue?vue&type=script&lang=js&"
export * from "./ProductActions.vue?vue&type=script&lang=js&"
import style0 from "./ProductActions.vue?vue&type=style&index=0&id=5c7ff91c&scoped=true&lang=css&"
import style1 from "./ProductActions.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7ff91c",
  null
  
)

export default component.exports